var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"view dashboard"},[_vm._m(0),_c('div',{staticClass:"tiles"},_vm._l((_vm.navigation),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.alias}},[_c('icon',{attrs:{"name":item.icon_id}}),_c('span',[_vm._v(_vm._s(item.title))])],1)}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('b',[_vm._v("Willkommen")]),_vm._v(" im Digitalen Projekthandbuch")])
}]

export { render, staticRenderFns }